<template lang="pug">
.page 
    a-tabs(tab-position="left")
        a-tab-pane(key="user")
            span(slot="tab")
                a-icon(type="user" style="margin-right:5px")
                span 用户管理
            User
        a-tab-pane(key="folder")
            span(slot="tab")
                a-icon(type="folder-open" style="margin-right:5px")
                span 文件管理
            File
        a-tab-pane(key="tradeAccount")
            span(slot="tab")
                a-icon(type="credit-card" style="margin-right:5px")
                span 交易账户
            TradeAccount
        a-tab-pane(key="log")
            span(slot="tab")
                a-icon(type="file-text" style="margin-right:5px")
                span 日志管理
            Log
</template>

<script>
import User from './User.vue'
import File from './File.vue'
import TradeAccount from './TradeAccount.vue'
import Log from './Log.vue'

export default {
    data() {
        return {

        };
    },
    components: {
        User,
        File,
        TradeAccount,
        Log
    }
}
</script>            